<template>
  <div class="el-empty base-empty">
    <div v-if="!noImage" class="el-empty__image" :style="imageStyle">
      <img v-if="imageSrc" :src="imageSrc" ondragstart="return false">
      <slot v-else name="image" />
    </div>
    <div class="el-empty__description">
      <slot v-if="$slots.description" name="description" />
      <p v-else>{{ description || defaultDescription }}</p>
    </div>
    <div v-if="$slots.default" class="el-empty__bottom">
      <slot />
    </div>
  </div>
</template>

<script>
import EmptyIcon1 from './images/empty.png'

export default {
  name: 'BaseEmpty',
  props: {
    noImage: {
      type: Boolean,
      default: false
    },
    type: {
      type: [Number, String],
      default: 1
    },
    src: {
      type: String,
      default: ''
    },
    size: {
      type: [Number, String],
      default: 180
    },
    description: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      emptyIcons: [EmptyIcon1]
    }
  },
  computed: {
    imageSrc() {
      if (this.src) {
        return this.src
      } else {
        return this.emptyIcons[+this.type - 1] || ''
      }
    },
    imageStyle() {
      return {
        width: parseInt(this.size) + 'px'
      }
    },
    defaultDescription() {
      if (this.type === 2) {
        return '正在开发中'
      } else {
        return '暂无数据'
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
